// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';

import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";
import { History, fetchHistory } from '../../history';
import { Response } from '../../response';

function Body(props) {
    const classes = FHMaterialStyles();    
    return(
        <Grid container direction="column" className={classes.adminRequestBodyContainer}>
          <History requestKey={props.requestKey} request={props.request}/>
          <Response request={props.request} />
        </Grid>
    );
}

export default Body;
